import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'

// components
import DeliveryInfo from '../../components/storeInfo/DeliveryInfo'
import Loading from '../../components/atom/loading/Loading'
import { HeaderTab } from '../../components'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'
import StoreContext from '../../globals/StoreContext'

// constants
const STORE_HEADER_ITEM = ['기본정보', '운영정보', '배달정보']

const StoreDeliveryInfo = () => {
  //매장 정보 조회 및 초기 매장정보
  const contextData = useContext(StoreContext)
  const { storeInfoData, getStoreInfo } = contextData || {}

  //로딩
  const setLoading = storeInfoData ? 'true' : 'false'

  const [deliveryData, setDeliveryData] = useState(null) // 배달 정보
  const [isDelivery, setIsDelivery] = useState(true) // 배달대행사 유무

  useEffect(() => {
    let resCode = storeInfoData?.responseCode
    let resData = storeInfoData?.responseData

    // let result = storeInfoData?.resultData ?? null

    switch (resCode) {
      // 조회 성공
      case TYPE.API_RESPONSE.SUCCESS:
        setDeliveryData(resData?.deliveryStoreInfo)
        setIsDelivery(
          Array.isArray(resData?.deliveryStoreInfo?.mappingDcList) &&
            resData?.deliveryStoreInfo?.mappingDcList?.length > 0,
        )
        break

      // 조회 실패
      case TYPE.API_RESPONSE.FAILURE:
      default:
        setDeliveryData(null)
        setIsDelivery(false)
        break
    }
  }, [storeInfoData])

  return (
    <>
      {!setLoading ? (
        <Loading />
      ) : (
        <>
          <HeaderTab
            isDesktop={true}
            headerLinks={[
              '/storeList',
              '/manageStoreInfo',
              '/storeDeliveryInfo',
            ]}
            headerItem={STORE_HEADER_ITEM}
            selectedItem={2}
          />

          <Container>
            <DeliveryInfo
              deliveryStoreInfo={deliveryData}
              isDelivery={isDelivery ? 'Y' : 'N'}
            />
          </Container>
        </>
      )}
    </>
  )
}

export default StoreDeliveryInfo

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
